import { Accordion, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import React from "react";
import VerBusinessDetails from "../../../components/common/VerBusinessDetails";
import { getCorrBank } from "../redux/action/getCorrBank";
import VerCorrBank from "./verCorrBank";

const VerLocalBank: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const state = useSelector(
    (state: RootState) => state.verification.verLocalBankDetails,
  );

  // ✅ Store corr banks per local bank ID
  const [corrBankData, setCorrBankData] = React.useState<{
    [key: number]: any[];
  }>({});

  // ✅ Optional loader per bank
  const [loadingBanks, setLoadingBanks] = React.useState<{
    [key: number]: boolean;
  }>({});

  if (!state.data || !state.data.data) {
    return <Row>Loading...</Row>;
  }

  const localBankStore = state.data.data.result.result;

  const handleCorrBankClick = (settlementBankId: number) => async () => {
    try {
      // ✅ prevent refetch if already loaded
      if (corrBankData[settlementBankId]) return;

      setLoadingBanks((prev) => ({ ...prev, [settlementBankId]: true }));

      const result = await dispatch(getCorrBank(settlementBankId));

      if (result.payload) {
        setCorrBankData((prev) => ({
          ...prev,
          [settlementBankId]: result.payload.data.result.result,
        }));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingBanks((prev) => ({ ...prev, [settlementBankId]: false }));
    }
  };

  return (
    <>
      <Accordion>
        {localBankStore.map((localBank: any, index: number) => (
          <Accordion.Item key={index} eventKey={`L${index}`}>
            <Accordion.Header>LOCAL BANK {index + 1}</Accordion.Header>

            <Accordion.Body>
              <Row md={12}>
                <Col md={6}>
                  <VerBusinessDetails
                    label="Bank Name"
                    defaultValue={localBank.bank_name}
                    colored={localBank.api_bank_name_flag}
                    required
                  />
                </Col>
                <Col md={6}>
                  <VerBusinessDetails
                    label="Branch Name"
                    defaultValue={localBank.branch_name}
                    colored={localBank.api_branch_name_flag}
                    required
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <VerBusinessDetails
                    label="Bank Account No"
                    defaultValue={localBank.bank_account_number}
                    required
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <VerBusinessDetails
                    label="Name as per Bank"
                    defaultValue={localBank.bank_account_name}
                    colored={localBank.api_account_name_flag}
                  />
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <VerBusinessDetails
                    label="Swift Code"
                    defaultValue={localBank.swift_code}
                  />
                </Col>
                <Col md={6}>
                  <VerBusinessDetails
                    label="Account Type"
                    defaultValue={
                      localBank.account_type === "Others"
                        ? localBank.other_account_type
                        : localBank.account_type?.toUpperCase()
                    }
                  />
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <VerBusinessDetails
                    label="IFSC"
                    defaultValue={localBank.ifsc_code}
                  />
                </Col>
                <Col md={6}>
                  <VerBusinessDetails
                    label="Currency"
                    defaultValue={localBank.currency_id.currency_code}
                  />
                </Col>
              </Row>

              {/* Address */}
              <Row>
                <Col>
                  <VerBusinessDetails
                    label="Address Line 1"
                    defaultValue={localBank.bank_address_line_1}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <VerBusinessDetails
                    label="Address Line 2"
                    defaultValue={localBank.bank_address_line_2}
                  />
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <VerBusinessDetails
                    label="City"
                    defaultValue={localBank.bank_address_city}
                  />
                </Col>
                <Col md={6}>
                  <VerBusinessDetails
                    label="District"
                    defaultValue={localBank.bank_address_district}
                  />
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <VerBusinessDetails
                    label="State"
                    defaultValue={localBank.bank_address_state}
                  />
                </Col>
                <Col md={6}>
                  <VerBusinessDetails
                    label="Country"
                    defaultValue={localBank.bank_address_country_id.name}
                  />
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <VerBusinessDetails
                    label="Pincode"
                    defaultValue={
                      localBank.bank_address_pincode === "0"
                        ? ""
                        : localBank.bank_address_pincode
                    }
                  />
                </Col>
              </Row>

              {/* ✅ CORR BANK ACCORDION */}
              <Accordion>
                <Accordion.Item eventKey="C1">
                  <Accordion.Header onClick={handleCorrBankClick(localBank.id)}>
                    Correspondent Banks
                  </Accordion.Header>

                  <Accordion.Body>
                    {loadingBanks[localBank.id] ? (
                      <Row>Loading...</Row>
                    ) : (
                      <VerCorrBank data={corrBankData[localBank.id] || []} />
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </>
  );
};

export default VerLocalBank;
